import { useRouter } from 'vue-router'
import { useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'
import { routes } from '@/router/routes'

export const useOperationNavigationShortcuts = () => {
  const router = useRouter()

  for (const route of routes) {
    if (!('meta' in route) || !('shortcut' in route.meta) || !route.name) {
      continue
    }

    useShortcut(route.meta.shortcut, () => {
      router.push({ name: route.name })
    })
  }
}
